// resources/js/_galleryMasonry.js
// import './_shuffleCentered.js';
import Shuffle from 'shufflejs';
import { reloadGalleryLightbox } from './_glightbox.js';

function initGalleryMasonry() {
  const containers = document.querySelectorAll('.gallery-masonry[data-gallery]');

  if (!containers.length) return;

  containers.forEach((container) => {
    const key = container.dataset.gallery; // "gallery-home"
    const sizer = container.querySelector('[data-shuffle-sizer]');
    const galleryItems = container.querySelectorAll('.gallery-item');

    const updateGalleryGroup = (filterValue) => {
      const galleryName =
        !filterValue || filterValue === '*'
          ? key
          : `${key}-${filterValue}`;

      galleryItems.forEach((item) => {
        item.dataset.gallery = galleryName;
      });
    };

    const shuffleInstance = new Shuffle(container, {
      itemSelector: '.gallery-item',
      sizer: sizer || null,
      // bisa tambahin opsi lain kalau perlu
      // speed: 500,
    });

    // handle filter button
    const filters = document.querySelector(
      `[data-gallery-filters="${key}"]`
    );

    if (!filters) return;

    filters.addEventListener('click', (event) => {
      const btn = event.target.closest('.filter-btn');
      if (!btn) return;

      const filterValue = btn.dataset.filter;

      // state active button
      filters.querySelectorAll('.filter-btn').forEach((button) => {
        button.classList.toggle('is-active', button === btn);
      });

      updateGalleryGroup(filterValue);
      reloadGalleryLightbox();

      if (!filterValue || filterValue === '*') {
        // tampilkan semua item
        shuffleInstance.filter(Shuffle.ALL_ITEMS);
      } else {
        // filter per kategori
        shuffleInstance.filter(filterValue);
      }
    });

    // optional: trigger layout ketika image sudah load
    // biar masonry-nya lebih rapi
    const images = container.querySelectorAll('img');
    let imagesLoaded = 0;

    if (images.length) {
      images.forEach((img) => {
        if (img.complete) {
          imagesLoaded++;
          if (imagesLoaded === images.length) {
            shuffleInstance.layout();
          }
        } else {
          img.addEventListener('load', () => {
            imagesLoaded++;
            if (imagesLoaded === images.length) {
              shuffleInstance.layout();
            }
          });
        }
      });
    }
  });
}

export default initGalleryMasonry;
